import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import FilmwebLogoSvg from 'src/components/svg/FilmwebLogoSvg';
import SomeFacebookSquareLogoSvg from 'src/components/svg/SomeFacebookSquareLogoSvg';
import SomeInstagramSquareLogoSvg from 'src/components/svg/SomeInstagramSquareLogoSvg';
import SomeTikTokLogoSvg from 'src/components/svg/SomeTikTokLogoSvg';
import TMDBSvg from 'src/components/svg/TMDBSvg';
import FooterHeading from 'src/footer/FooterHeading';
import GDPRChangeButton from 'src/footer/GDPRChangeButton';
import Newsletter from 'src/footer/Newsletter';
import classNames from 'classnames';
import styles from './Footer.module.css';
import ISettings from 'src/lib/types/Settings';

//#region [Props]
type FooterProps = {
  appSettings: ISettings;
};
//#endregion

//#region [Component]
export default function Footer({ appSettings }: FooterProps) {
  return (
    <footer className={styles.SFooter}>
      <div className={styles.SFooterContainer}>
        <Newsletter />

        <div className={styles.SFooterSection}>
          <FooterHeading>Kundeservice</FooterHeading>
          <div>Vi hjelper deg gjerne.</div>
          <div>Her finner du svar på dine spørsmål:</div>
          <div className={styles.SLinks}>
            <FilmwebLink to="https://kundeservice.filmweb.no/">Kundeservice</FilmwebLink>
            <FilmwebLink to="https://annonse.filmweb.no/nb/">Annonsere på Filmweb?</FilmwebLink>
          </div>
        </div>

        <div className={styles.SFooterSection}>
          <FooterHeading>Våre tjenester</FooterHeading>
          <div>Vi tilbyr en rekke</div>
          <FilmwebLink to="/filmnytt/filmweb-sine-tjenester">tjenester og produkter</FilmwebLink>.
        </div>

        <div className={styles.SFooterSection}>
          <FooterHeading>Følg oss</FooterHeading>
          <div className={styles.SSomeLinks}>
            <FilmwebLink to="https://www.facebook.com/filmweb.no" rel="noopener noreferrer">
              <SomeFacebookSquareLogoSvg />
            </FilmwebLink>
            <FilmwebLink to="https://www.instagram.com/filmwebno/" rel="noopener noreferrer">
              <SomeInstagramSquareLogoSvg />
            </FilmwebLink>
            <FilmwebLink to="https://www.tiktok.com/@filmweb.no" rel="noopener noreferrer">
              <SomeTikTokLogoSvg />
            </FilmwebLink>
          </div>
        </div>

        <div className={styles.SFooterSection}>
          This product uses the TMDB API but is not endorsed or certified by TMDB.
          <FilmwebLink to="https://www.themoviedb.org/" rel="noopener noreferrer">
            <TMDBSvg />
          </FilmwebLink>
        </div>

        <div className={classNames(styles.SFooterSection, styles.SCookieSection)}>
          <div>
            <GDPRChangeButton />
          </div>
          <div>
            Filmweb bruker{' '}
            <FilmwebLink to={`/filmnytt/${appSettings.cookiePolicy.current}`}>cookies</FilmwebLink>. Våre{' '}
            <FilmwebLink to={`/filmnytt/${appSettings.termsAndConditions.current}`}>brukervilkår</FilmwebLink>.
          </div>
          <div>Adm. Dir: Harald Lobak Sæther</div>
        </div>

        <div className={styles.SLogoSection}>
          <FilmwebLogoSvg />
        </div>
      </div>
    </footer>
  );
}
//#endregion
